import { gameActionTypes } from './constants';

import type { Href } from '@/shared/utils/href';
import type { JuniorSessionResult } from '../api/juniorSessionResult';
import type { GameData } from '../types';

export function getGameDataRequest() {
	return {
		type: gameActionTypes.GET_GAME_DATA_REQUEST,
	};
}

export function getGameDataSuccess(gameData: GameData, sessionEndHref?: Href) {
	return {
		type: gameActionTypes.GET_GAME_DATA_SUCCESS,
		payload: { gameData, sessionEndHref },
	};
}

export function getGameDataError() {
	return {
		type: gameActionTypes.GET_GAME_DATA_ERROR,
	};
}

export function clearGameState() {
	return {
		type: gameActionTypes.CLEAR_GAME_STATE,
	};
}

export function finishGameRequest(payload: JuniorSessionResult, onFinished?: () => void) {
	return {
		type: gameActionTypes.FINISH_GAME_REQUEST,
		payload,
		meta: { onFinished },
	};
}

export function finishGameSuccess() {
	return {
		type: gameActionTypes.FINISH_GAME_SUCCESS,
	};
}

export function finishGameError() {
	return {
		type: gameActionTypes.FINISH_GAME_ERROR,
	};
}

export function setCurrentLevel(currentLevel: any) {
	return {
		type: gameActionTypes.SET_CURRENT_LEVEL,
		payload: { currentLevel },
	};
}
